export class IboxtoolsItem {
    public id:number;
	public title:string;
    public desde:any;
    public hasta:any;
    
    constructor(data:any){
        this.id = data?.id;
        this.desde = data?.desde;
        this.hasta = data?.hasta;
    }
}
